/* eslint-disable */
import React from 'react';
import { styled } from '@mui/material/styles';

import UIKitChipBase, { UIKitChipSize } from './ChipBase';
import UIKitIcon from '../Icon';
import { colors } from '../../theme/tokens.colors';

const IMPORTANT = ' !important';

export type UIKitPerformanceVariant = 'S' | 'PS' | 'PU' | 'U';

export interface UIKitPerformanceChipProps {
  htmlId?: string;
  variant: string;
  size?: UIKitChipSize;
  className?: string;
  style?: React.CSSProperties;
}

const StyledChipBase = styled(UIKitChipBase)({
  borderColor: colors.neutralVariant[300] + IMPORTANT,
  backgroundColor: colors.specialColors.white + IMPORTANT,
  color: colors.neutral[900] + IMPORTANT,
  boxShadow: 'none',
});

const IconWrapper = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  height: 16,
  borderRadius: '50%',
  color: colors.specialColors.white,
  flex: '0 0 auto',
});

const StyledIcon = styled(UIKitIcon)({
  fontSize: 14,
  lineHeight: 1,
});

export const PERFORMANCE_CONFIG: Record<
  UIKitPerformanceVariant,
  {
    label: string;
    color: string;
    direction: 'up' | 'down';
  }
> = {
  S: {
    label: 'S',
    color: colors.success[500],
    direction: 'up',
  },
  PS: {
    label: 'PS',
    color: colors.success[300],
    direction: 'up',
  },

  // Error group
  PU: {
    label: 'PU',
    color: colors.error[500],
    direction: 'down',
  },
  U: {
    label: 'U',
    color: colors.error[600],
    direction: 'down',
  },
};

const UIKitPerformanceChip: React.FC<UIKitPerformanceChipProps> = ({
  htmlId,
  variant,
  size = 'medium',
  className,
  style,
}) => {
  const performanceValues: { [key: string]: UIKitPerformanceVariant } = {
    Satisfactory: 'S',
    'Partially Satisfactory': 'PS',
    Unsatisfactory: 'U',
    'Partially Unsatisfactory': 'PU',
  };

  const cfg = PERFORMANCE_CONFIG[performanceValues[variant]];

  const iconName = cfg.direction === 'up' ? 'arrow_upward' : 'arrow_downward';

  const iconLeft = (
    <IconWrapper style={{ backgroundColor: cfg.color }}>
      <StyledIcon name={iconName} size="xs" />
    </IconWrapper>
  );

  return (
    <StyledChipBase
      htmlId={htmlId}
      size={size}
      label={cfg.label}
      iconLeft={iconLeft}
      className={className}
      style={style}
    />
  );
};

export default UIKitPerformanceChip;
